import script from "./FormulasIngredientSelectableSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientSelectableSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredientSelectableSelect.vue?vue&type=style&index=0&id=157894c0&lang=scss"

const __exports__ = script;

export default __exports__